import { CancelOutlined, Phone } from "@mui/icons-material";
import { Alert } from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { devLog } from "utils/devLog";

const searchTypeMap = new Map();

export default function CARSMemberSearchForm(props) {
  const { t } = useTranslation();
  const LAST8VIN = "LAST8VIN";
  const CONTRACT_NUMBER = "CONTRACT_NUMBER";

  const formRef = useRef();
  const [last8Vin, setLast8Vin] = useState(props.currState?.MemberLookup.last8Vin || props.currState.last8Vin || "");
  const [contractNumber, setContractNumber] = useState(
    props.currState?.MemberLookup.contractNumber || props.currState.contractNumber || "",
  );
  const [odometer, setOdometer] = useState(props.currState?.MemberLookup.odometer || props.currState.Odometer || "");
  const [memberNumber, setMemberNumber] = useState(
    props.currState?.MemberLookup.memberNumber || props.currState.memberNumber || "",
  );
  const [lessThanEightVin, setLessThanEightVin] = useState(false);
  const [lessThanSixCN, setLessThanSixCN] = useState(false);

  const [searchTypes, setSearchTypes] = useState([
    { key: LAST8VIN, value: t("description.ConfirmCustomerLast8VIN1") },
    { key: CONTRACT_NUMBER, value: t("ATF.ContractSearch.DropdownOptions7") },
  ]);

  const [selectedSearchTypes, setSelectedSearchTypes] = useState(props.currState.MemberLookup?.searchType || LAST8VIN);

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    devLog(selectedSearchTypes);
    setLast8Vin(last8Vin);
    setContractNumber(contractNumber);
    setOdometer(odometer);
    setMemberNumber(memberNumber);
  }, [selectedSearchTypes]);

  useEffect(() => {
    if (typeof props.onFormUpdated === "function") {
      props.onFormUpdated({
        last8Vin: last8Vin,
        odometer: odometer,
        contractNumber: contractNumber,
        memberNumber: memberNumber,
        searchType: selectedSearchTypes,
      });
    }
  }, []);

  const windowWidth = () => {
    if (width < 720) {
      return "group-1 group-v2 input-v2";
    } else {
      return "group-1";
    }
  };

  const windowWidth2 = () => {
    if (width < 720) {
      return "label label-v2";
    } else {
      return "label";
    }
  };

  const onSubmit = (e) => {
    devLog("onSubmit", e);
    e.preventDefault();
    if (last8Vin.length < 8 && selectedSearchTypes === LAST8VIN) {
      setLessThanEightVin(true);
      return;
    } else if (contractNumber.length < 6 && selectedSearchTypes === CONTRACT_NUMBER) {
      setLessThanSixCN(true);
      return;
    }
    if (typeof props.onFormSubmit === "function") {
      props.onFormSubmit({
        last8Vin: last8Vin,
        odometer: odometer,
        contractNumber: contractNumber,
        memberNumber: memberNumber,
        searchType: selectedSearchTypes,
      });
    }
    return false;
  };

  const vinInputLength = (e) => {
    if (e.target.value.length > 8) {
      e.target.value = e.target.value.slice(0, -1);
      devLog("Vin Length error");
    }
  };

  // const contractNumberLen = (e) => {
  //   if (e.target.value.length > 6) {
  //     e.target.value = e.target.value.slice(0, -1);
  //     devLog("Contract Number Length error");
  //   }
  // };

  return (
    <>
      <div className="formContainer">
        <form ref={formRef} onSubmit={onSubmit} className="form">
          <Dropdown
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
            }}
          >
            <Dropdown.Toggle style={{ color: "white" }} variant="dark" id="dropdown-basic">
              {searchTypes.find((opt) => opt.key == selectedSearchTypes)?.value}
            </Dropdown.Toggle>
            <Dropdown.Menu variant="dark">
              {searchTypes.map((searchType) => {
                return (
                  <Dropdown.Item
                    active={searchType.key === selectedSearchTypes}
                    onClick={(e) => setSelectedSearchTypes(searchType.key)}
                  >
                    {searchType.value}
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Dropdown>

          {/* <div className="single-search">
            {t("description.DropdownOptions1")}
          </div> */}

          {/*LAST 8 VIN*/}
          {selectedSearchTypes === LAST8VIN && (
            <>
              <div className={windowWidth()}>
                <div className={windowWidth2()}>{t("description.DropdownOptions1")}:</div>
                <input
                  type="string"
                  placeholder="ex: AB123CD4"
                  name="last8Vin"
                  className="input form-control required"
                  value={last8Vin}
                  onChange={(e) => {
                    vinInputLength(e);
                    setLast8Vin(e.target.value?.trim()?.toUpperCase() || "");
                  }}
                  required={true}
                />
              </div>
              {lessThanEightVin && <Alert severity="error">{t("description.VinInputLessErrorMsg")}</Alert>}
            </>
          )}

          {/*Contract Number*/}
          {selectedSearchTypes === CONTRACT_NUMBER && (
            <>
              <div className={windowWidth()}>
                <div className={windowWidth2()}>{t("ATF.ContractSearch.DropdownOptions7")}:</div>
                <input
                  type="string"
                  name="contractNumber"
                  className="input form-control required"
                  value={contractNumber}
                  onChange={(e) => {
                    // contractNumberLen(e);
                    setContractNumber(e.target.value?.trim() || "");
                  }}
                  required={true}
                />
              </div>
              {lessThanSixCN && <Alert severity="error">{t("description.CNInputLessErrorMsg")}</Alert>}
            </>
          )}

          {/*Odometer*/}
          {(selectedSearchTypes === CONTRACT_NUMBER || selectedSearchTypes === LAST8VIN) && (
            <>
              <div className={windowWidth()}>
                <div className={windowWidth2()}>{t("description.ConfirmCustomerOdometer1")}:</div>
                <input
                  type="number"
                  name="odometer"
                  className="input form-control required"
                  value={odometer}
                  onChange={(e) => {
                    // contractNumberLen(e);
                    setOdometer(e.target.value?.trim() || "");
                  }}
                  required={true}
                />
              </div>
            </>
          )}

          <div className="footerContainer">
            <div>
              <button
                id="cancelButton"
                type="button"
                className="footer"
                style={{
                  background: "#f4f4f4",
                  color: "black",
                  paddingLeft: 14,
                }}
                onClick={(e) => {
                  e.preventDefault();
                  devLog("UI Cancel pressed");
                  if (typeof props.onUserCancel === "function") {
                    props.onUserCancel();
                  }
                }}
              >
                <CancelOutlined style={{ width: 20, color: "black", marginRight: 4 }} />
                <span style={{ marginLeft: "0px" }}>{t("description.CancelCallButton1")}</span>
              </button>
            </div>
            <button type="submit" className="ui-btn">
              {t("description.ConfirmCustomerSubmit")}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
